var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 0.5,
    width: 18.16,
    height: 29,
    rx: 3,
    fill: "#101AA1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2.30664,
    width: 13.5484,
    height: 21.6774,
    rx: 2,
    fill: "#9B9ECD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.32258,
    height: 1.80645,
    rx: 0.903226,
    transform: "matrix(1 0 0 -1 12 26.6934)",
    fill: "#9B9ECD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.b25ef36442ed747ede85d48e0de4c40b.svg";
export { ForwardRef as ReactComponent };